import React, { useCallback } from "react";
import Tooltip from "devextreme-react/tooltip";
import PropTypes from "prop-types";
import "./TimeElapseWithTooltip.scss";
import { ResourceDeprecate } from "../../Assets/SVGs/ResourceSVGs";

// Utility function to calculate the arc path for the pie chart
const calculateArcPath = (percentage, radius) => {
  const angle = (percentage / 100) * 360; // Convert percentage to angle

  const largeArcFlag = angle > 180 ? 1 : 0; // Determines if the arc should be greater than 180 degrees

  const startAngle = 0;
  const endAngle = angle;

  const startX = radius * Math.cos((startAngle - 90) * (Math.PI / 180)) + 100;
  const startY = radius * Math.sin((startAngle - 90) * (Math.PI / 180)) + 100;
  const endX = radius * Math.cos((endAngle - 90) * (Math.PI / 180)) + 100;
  const endY = radius * Math.sin((endAngle - 90) * (Math.PI / 180)) + 100;

  return `M100,100 L${startX},${startY} A${radius},${radius} 0 ${largeArcFlag},1 ${endX},${endY} Z`;
};

const TimeElapseWithTooltip = ({ daysLeft, id }) => {
  // Define the total number of days for a full circle
  const totalDays = 30;

  // Calculate the percentage of the remaining days
  const percentage = (daysLeft / totalDays) * 100;

  // Define the radius of the pie chart
  const pieChartRadius = 35;

  // Calculate the arc path based on percentage and new radius
  const arcPath = calculateArcPath(percentage, pieChartRadius);

  // Gap size between the outer circle and the pie sector
  const gapSize = 10;

  const tooltipContentRender = useCallback(
    () => <> {daysLeft ? `Expires in ${daysLeft} days` : "Expired"} </>,
    [daysLeft]
  );

  const wrapperAttributes = {
    id: "subscribeTabTooltip",
  };

  return (
    <div>
      {daysLeft ? (
        <svg id={`c${id}`} width={24} height={24} viewBox="0 0 225 225">
          {/* Outer Circle */}
          <circle
            cx={100}
            cy={100}
            r={50}
            stroke="#ffa500"
            strokeWidth={gapSize}
            fill="none"
          />
          {/* Pie chart sector */}
          <path d={arcPath} fill="#ffa500" />
        </svg>
      ) : (
        <span id={`d${id}`} className="resource-deprecate">
          {ResourceDeprecate}
        </span>
      )}

      <Tooltip
        target={daysLeft ? `#c${id}` : `#d${id}`}
        contentRender={tooltipContentRender}
        showEvent="mouseenter"
        hideEvent="mouseleave"
        position="top"
        wrapperAttr={wrapperAttributes}
      />
    </div>
  );
};

TimeElapseWithTooltip.propTypes = {
  daysLeft: PropTypes.number,
  id: PropTypes.string,
};

export default TimeElapseWithTooltip;
